import privacyPolicy from '../rw-privacy-policy/components/reducers/privacy-policy';

export default privacyPolicy;



// WEBPACK FOOTER //
// ./src/modules/utils/reducers/privacy-policy.reducer.js